import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MetaService, TranslationService } from 'services/core';
import { Language } from '@/interfaces/common';
import * as MetaInfo from '@/helpers/metaInfo';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit, OnDestroy {
  private subLang: Subscription = Subscription.EMPTY;

  constructor(
    private metaService: MetaService,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this.updateMeta(this.translationService.getCurrentLanguage());
    this.subLang = this.translationService
      .getCurrentLanguageAsObservable()
      .subscribe(lang => this.updateMeta(lang));
  }

  ngOnDestroy() {
    this.subLang.unsubscribe();
  }

  private updateMeta(lang: Language) {
    const info = MetaInfo.all[MetaInfo.Page.AllAds];
    this.metaService.updateTitle(info[lang].title);
    this.metaService.updateDescription(info[lang].description);
  }
}
